import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";
import { homeGif } from "../assets";

function HomePage({ isAuthenticated }) {
  return (
    <section className="home">
      <div className="home__inner">
        <div className="home__text">
		  <h1 className="home__title">Witaj w systemie CST</h1>

		  <div className="home__tags">
			<p className="home__tag">
			  System gotowy: czekamy już tylko na Twoje pomysły.
			</p>
			<p className="home__tag">
			  Gotowy na update możliwości?
			</p>
		  </div>

		  {!isAuthenticated && (
			<Link to="/login" className="main-login-btn">
			  Zaloguj
			</Link>
		  )}
		</div>

        <div className="home__media">
          <img
            src={homeGif}
            alt="CST – idea, komunikacja, organizacja"
            className="home__gif home__gif--big"
            loading="eager"
          />
        </div>
      </div>

      {/* DODANE: sekcja z trzema kartami – lekki, informacyjny akcent */}
      <div className="features-grid">
        <article className="feature-card">
          <div className="feature-emoji">💡</div>
          <h3>Idea</h3>
          <p>Od pomysłu do realizacji – zamieniaj zgłoszenia w zlecenia jednym kliknięciem.</p>
        </article>
        <article className="feature-card">
          <div className="feature-emoji">🗣️</div>
          <h3>Komunikacja</h3>
          <p>Wspólna tablica statusów, komentarze i historia zmian – wszystko w jednym miejscu.</p>
        </article>
        <article className="feature-card">
          <div className="feature-emoji">🗂️</div>
          <h3>Organizacja</h3>
          <p>Kalendarz zespołu, priorytety i filtrowanie – pełna kontrola nad pracą.</p>
        </article>
      </div>
    </section>
  );
}

export default HomePage;
